<div class="ada-full-height ada-display-flex ada-flex-direction-column">
	@if (aida.isChatView() && (aiProductName | adaIsLicensed | async)) {
		<div class="ada-container ada-col-1 ada-colspan-1 llm-switch-wrapper ada-border-inner-bottom ada-sticky-top ada-fixedhw">
			<ada-llm-switch
				[rowsPerPage]="5"
				[style.flex]="1"
			/>
			<button
				aria-label="New Chat"
				class="ada-btn ada-btn-sm ada-btn-icon ada-btn-no-margin ada-btn-no-padding"
				data-testid="llm-new-chat-button"
				title="New Chat"
				(click)="startConversation()"
			>
				<ada-icon icon="faPlus" />
			</button>
		</div>
		<ada-tabs-container
			class="ada-overflowY-auto ada-flex-grow ada-flex-shrink"
			[icons]="tabIcons()"
			[tabNames]="tabNames"
			[(selectedTab)]="aida.currentTab"
		>
			<ada-llm-chat *adaTemplateMarker />
			<ada-llm-forks *adaTemplateMarker />
			<ada-llm-history *adaTemplateMarker />
			<div
				class="ada-llm-search-button-wrap"
				data-container-selector="ada-tab-header-insert"
			>
				<button
					aria-label="Search"
					class="ada-btn ada-btn-sm ada-btn-icon ada-btn-flat ada-btn-no-margin ada-btn-no-padding"
					data-testid="llm-search-button"
					title="Search"
					(click)="aida.toggleSearch()"
				>
					<ada-icon icon="faSearch" />
				</button>
			</div>
		</ada-tabs-container>
	} @else {
		<ada-llm-free-trial />
	}
</div>
